export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "Please check the required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["選択してください"])}
    }
  })
}
